<template>
  <section class="smart-recruiters-detail__section smart-recruiters-detail__section-five">
    <!-- eslint-disable vue/no-v-html -->
    <blockquote
      class="smart-recruiters-detail__quote"
      v-html="fields.quote?.value"
    />
    <!-- eslint-enable vue/no-v-html -->
  </section>
</template>

<script setup lang="ts">
import { useFields } from '@/composables/fields';

defineOptions({ name: 'SmartRecruitersDetailSectionFive' });

const fields = useFields('SmartRecruitersDetailPageFields');
</script>

<style src="./smart-recruiters-detail-section-five" />
